import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArchivosExpedientesService {
  constructor(private readonly http: HttpClient) {}

  private readonly apiUrl = `${environment.rrhhUrl}/archivos`;

  /**
   * Obtiene los archivos de un empleado para un documento específico del expediente.
   * @param idEmpleado
   * @param idDocumentoExpediente
   * @returns Observable<Blob>
   */
  obtenerPorEmpleado(idEmpleado: number, idDocumentoExpediente: number) {
    return this.http.get(`${this.apiUrl}/${idEmpleado}`, {
      params: { idDocumentoExpediente: idDocumentoExpediente.toString() },
      responseType: 'blob',
    });
  }
}
